import React from 'react';

const capabilities = [
  'Longitudinal monitoring',
];

const Monitoring = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-tealLight/30 to-paper">
      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
        <h1 className="font-serif font-bold text-4xl sm:text-5xl leading-tight tracking-tight text-[#085041]">
          <span className="text-[#0F6E56]">Monitoring</span>
        </h1>

        <p className="mt-6 text-lg leading-relaxed text-slate-700 max-w-3xl">
          Longitudinal intelligence for understanding how disease-associated
          signals and patient state change over time.
        </p>

        <section className="mt-10 bg-white border border-slate-200 rounded-xl p-8 sm:p-10 shadow-[6px_6px_0_rgba(15,110,86,0.14)]">
          <h2 className="font-serif font-bold text-2xl text-[#085041]">
            Monitoring Capability
          </h2>

          <div className="mt-6">
            {capabilities.map((item) => (
              <div
                key={item}
                className="border border-slate-200 rounded-lg p-5 bg-slate-50 max-w-md"
              >
                <p className="text-slate-700 font-medium">{item}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-8 grid md:grid-cols-2 gap-6">
          <div className="bg-white border border-slate-200 rounded-xl p-6">
            <h3 className="font-semibold text-[#085041] mb-3">
              Longitudinal Context
            </h3>
            <p className="text-slate-600 leading-relaxed">
              Connects observations across time to provide context for
              understanding changes in disease-associated signals and patient
              state.
            </p>
          </div>

          <div className="bg-white border border-slate-200 rounded-xl p-6">
            <h3 className="font-semibold text-[#085041] mb-3">
              Evolving Monitoring
            </h3>
            <p className="text-slate-600 leading-relaxed">
              Provides a foundation for incorporating repeated clinical,
              diagnostic, acoustic, imaging, and other longitudinal data as
              monitoring capabilities evolve.
            </p>
          </div>
        </section>
      </section>
    </div>
  );
};

export default Monitoring;
